export const hasBarcodeIdentifier = (
  identifiers: Array<string | null | undefined>
) => identifiers.filter(Boolean).join(" ").toLowerCase().includes("barcode");

interface ScannerCadenceEvent {
  eventType: string;
  eventGapMs: number;
  handlerGapMs: number;
}

export const hasConsecutiveRapidKeydownCadence = (
  events: ScannerCadenceEvent[],
  minimumRapidGaps: number,
  maximumGapMs: number
) => {
  let rapidGaps = 0;
  return events.some((event) => {
    if (event.eventType !== "keydown") return false;
    const gapMs = event.eventGapMs || event.handlerGapMs;
    if (gapMs > 0 && gapMs <= maximumGapMs) {
      rapidGaps += 1;
    } else if (gapMs > maximumGapMs) {
      rapidGaps = 0;
    }
    return rapidGaps >= minimumRapidGaps;
  });
};
